<template>
    <div class="card border-0 bg-transparent">
        <div class="bg-white p-3 rounded-4">
        <img :src="blog.default_image ? blog.default_image.medium : 'https://placehold.co/600x400/png'" 
             class="card-img-top rounded-4 mb-3" 
             :alt="blog.name"
             style="height: 250px; object-fit: cover;">
            <h5 class="fw-bold mb-2 text-truncate" :title="blog.name">{{ blog.name }}</h5>
            <p class="text-muted small">
                {{ blog.created_at_human  }} 
                <!-- Assuming resource has created_at_human or use format -->
            </p>
            <a :href="'/blog/' + blog.id" class="btn btn-outline-brown rounded-pill btn-sm px-3"
                style="width: fit-content;">Read More <i class="bi bi-arrow-right ms-1"></i></a>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        blog: {
            type: Object,
            required: true
        }
    }
}
</script>
